const PALETTES = [
  ["#00F0FF", "#0E1338"],
  ["#8B5CF6", "#0E1338"],
  ["#EC4899", "#0E1338"],
  ["#00F0FF", "#1A1040"],
  ["#7C3AED", "#05131F"],
];

const hashSeed = (seed) => {
  let h = 2166136261;
  for (let i = 0; i < seed.length; i++) {
    h ^= seed.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
};

export const PixelAvatar = ({ seed, className = "" }) => {
  let h = hashSeed(seed);
  const palette = PALETTES[h % PALETTES.length];
  const next = () => {
    h = (Math.imul(h, 1103515245) + 12345) >>> 0;
    return h;
  };
  const half = [];
  for (let i = 0; i < 15; i++) half.push(next() % 3 !== 0);

  const cells = [];
  for (let row = 0; row < 5; row++) {
    for (let col = 0; col < 5; col++) {
      const mirrorCol = col < 3 ? col : 4 - col;
      if (half[row * 3 + mirrorCol]) cells.push([col, row]);
    }
  }

  return (
    <svg viewBox="0 0 5 5" shapeRendering="crispEdges" className={className} aria-hidden="true">
      <rect width="5" height="5" fill={palette[1]} />
      {cells.map(([x, y]) => (
        <rect key={`${x}-${y}`} x={x} y={y} width="1" height="1" fill={palette[0]} />
      ))}
    </svg>
  );
};
